import React, { Component } from "react";
import { Input, Button } from "reactstrap";

import Slider from "../../../Slider";
import TYDatePicker from "../../../TYDatePicker";
import TYCheckBox from "../../../TYCheckBox";
import Registry from "../../../../Utils/Registry";
import ConfirmationModal from "../../../ConfirmationModal";
import Helpers from "../../../../Utils/Helpers";


export default class ExportFormRecurrent extends Component{
    state = {
        dayFrequence: 7,
        frequencyMode: null,
        hasEndingDate: false,
        startDate: new Date(),
        endDate: null,
        toEmails: [],
        title: "",
        confirmOpen: false,
        errors: {},
        format: "excel"
    };

    static defaultProps = {
        onSumbit: data => {},
        onCancel: () => {},
        onRemove: () => {},
        editMode: false,
        data: {}
    };

    componentDidMount(){
        this.id = Helpers.uniqId();

        if(!this.props.editMode){
            let user = Registry.registered("user");
            if(user)
                this.addDest(user.email);
            this.setState({frequencyMode: 'every-x-days'})
        }
        else
            this.initUpdateInputs();
    }

    initUpdateInputs = () => {
        const { data } = this.props;
        let state = {};
        
        state.title = data.name;
        state.toEmails = data.send_to;
        state.dayFrequence = data.frequency;
        state.frequencyMode = data.frequency !== null ? 'every-x-days' : 'every-last-days';
        state.startDate = new Date(data.next_export_date);
        state.hasEndingDate = data.export_until !== null;
        state.endDate = state.hasEndingDate ? new Date(data.export_until) : null
        state.format = data.format;

        this.setState(state);
    }

    resetData = () => {
        let state = {};
        const user = Registry.registered("user");
        
        state.title = "";
        state.toEmails = [user.email];
        state.dayFrequence = 1;
        state.frequencyMode = 'every-x-days';
        state.startDate = new Date();
        state.hasEndingDate = false
        state.endDate = null;
        state.format = "excel";

        this.setState(state);
    };

    updateDest = (index, email) => {
        let e = this.state.toEmails;
        if(index < e.length){
            e[index] = email;
            this.setState({toEmails: e});
        }
    }

    addDest = (destEmail="") => {
        let e = this.state.toEmails;
        e.push(destEmail);
        this.setState({toEmails: e});
    }

    removeDest = index => {
        let e = this.state.toEmails.slice();
        e.splice(index, 1);
        this.setState({toEmails: e});
    };

    setFrequencyMode = e => {
        this.setState({frequencyMode: e.target.value});
    }

    setFormat = e => this.setState({format: e.target.value});

    exportData = () => {
        const { dayFrequence, frequencyMode, hasEndingDate, startDate, endDate, toEmails, title, format } = this.state;
        const { data, onSubmit, editMode } = this.props;
        this.setState({errors: {}});
        const toEmailsFiltered = toEmails.filter(email => email.length > 0);
        const diff = (hasEndingDate && endDate && startDate) ? endDate.getTime() - startDate.getTime() : 0;

        if(title && startDate && ((hasEndingDate && endDate && diff > 0) || !hasEndingDate) && toEmailsFiltered.length){
            let PData = {
                name: title,
                send_to: toEmailsFiltered.join(","),
                next_export_date: startDate.toMysqlFormat(false)
            };

            if(editMode)
                PData.format = format;

            if(hasEndingDate)
                PData.export_until = endDate.toMysqlFormat(false);
            else if(editMode && !hasEndingDate && data.export_until)
                PData.export_until = "";

            if(frequencyMode === "every-x-days")
                PData.frequency = dayFrequence;

            onSubmit && onSubmit(PData);

            if(!editMode){
                this.resetData();
                window.scrollTo(0, 0);
            }
        }
        else{
            // Handle inputs errors
            let errors = {};
            if(!title)
                errors.title = "Il nous faut un nom pour votre export";
            if(!startDate)
                errors.startDate = "Il manque une date de demarrage pour votre export";
            if(hasEndingDate && !endDate)
                errors.endDate = "Il manque une date d'arret pour votre export";
            else if(hasEndingDate && startDate && endDate && diff <= 0)
                errors.endDate = "La date de fin doit être posterieure à la date de début";
            if(!toEmailsFiltered.length)
                errors.toEmails = "Nous n'avons personne avec qui partager cet export";
            this.setState({errors});
        }
    };

    showConfirmModal = () => {
        const { onRemove } = this.props;

        let removeAct = () => {
            this.setState({confirmOpen: false}, onRemove);
        };

        let refuseAct = () => this.setState({confirmOpen: false});

        return <ConfirmationModal 
            isOpen
            content="Êtes-vous sûr de vouloir supprimer l'export ?"
            validate={removeAct}
            refuse={refuseAct}
        />;
    }

    render(){
        const { 
            dayFrequence, 
            frequencyMode, 
            hasEndingDate, 
            startDate, 
            endDate, 
            toEmails, 
            title, 
            confirmOpen ,
            errors,
            format
        } = this.state;

        const { editMode, onCancel } = this.props;

        return <div>
            <div className={"bold " + (editMode ? ' marg-t-20' : '')}>R&eacute;p&eacute;ter *</div>
            <br />

            <div className={`${editMode && 'wp-50 '}`}>
                { /* Frequency range select mode */ }
                <div>
                    <Input 
                        type="radio" 
                        name={`repeatMode-${this.id}`}
                        className="marg-l-0 marg-r-10 relative" 
                        value="every-x-days"
                        checked={frequencyMode === 'every-x-days'}
                        onChange={this.setFrequencyMode} 
                    />

                    Tout les <span className="blue">{dayFrequence}</span> jour{dayFrequence > 1 ? 's' : ''}
                    
                    <div className="marg-l-20">
                        <Slider 
                            showMinmax 
                            min={1} 
                            max={28} 
                            value={dayFrequence} 
                            onChange={v => { this.setState({dayFrequence: v})}} 
                        />
                    </div>
                </div>

                { /* End of month mode */ }
                <div>
                    <Input 
                        type="radio" 
                        name={`repeatMode-${this.id}`}
                        className="marg-l-0 marg-r-10 relative" 
                        value="every-last-days"
                        onChange={this.setFrequencyMode} 
                        checked={frequencyMode === "every-last-days"}
                    />

                    Tous les derniers jours du mois<br />
                </div>
                <br />

                { /* Format select mode */ }
                {
                    editMode && <div>
                        <div className="bold">Format de l'export *</div>
                        <br />
                        <Input 
                            type="radio" 
                            name={`format-${this.id}`}
                            className="marg-l-0 marg-r-10 relative" 
                            value="excel"
                            checked={format === 'excel'}
                            onChange={this.setFormat} 
                        />
                        Excel
                        <br />
                        <Input 
                            type="radio" 
                            name={`format-${this.id}`}
                            className="marg-l-0 marg-r-10 relative" 
                            value="csv"
                            checked={format === 'csv'}
                            onChange={this.setFormat} 
                        />
                        CSV
                        <br />
                        <br />
                    </div>
                }
                
                { /* Start Date selection */ }
                <div className="bold">Date du prochain export *</div>
                <br />
                <div>
                    { errors.startDate && <p className="red">{errors.startDate}</p> }
                    <TYDatePicker 
                        selectedDate={startDate}
                        className="ty-calendar-wp-100"
                        inputClassName={errors.startDate ? 'error' : ''} 
                        onDatePicked={date => { 
                            this.setState({startDate: date});
                        }} 
                    />
                </div>
                <br />

                { /* End Date selection */ }
                <div className="bold d-flex">
                    <TYCheckBox
                        className="marg-r-10"
                        checked={hasEndingDate}
                        onToggle={s => { this.setState({hasEndingDate: s}); }}
                    /> Ajouter une date de fin
                </div>
                <br />
                <div className="marg-l-20">
                    { errors.endDate && <p className="red">{errors.endDate}</p> }
                    <TYDatePicker 
                        disabled={!hasEndingDate}
                        selectedDate={endDate}
                        inputClassName={errors.endDate ? 'error' : ''} 
                        className="ty-calendar-wp-100" 
                        onDatePicked={date => { 
                            this.setState({endDate: date});
                        }} 
                    />
                </div>
                <br />

                { /* Email dest */ }
                <div className="bold">Destinataires *</div>
                <br />
                <div className="wrap-between-sm-md">
                    { errors.toEmails && <p className="red">{errors.toEmails}</p> }
                    {
                        toEmails.map((email, i) => {
                            return <div className="d-flex align-items-center marg-b-10" key={`dest-extract-${i}-${this.id}`}>
                                <Input
                                    placeholder="Email ..."
                                    type="text"
                                    className={errors.toEmails ? 'error' : ''}
                                    value={email}
                                    onChange={e => { this.updateDest(i, e.target.value)} }
                                />
                                { 
                                    editMode ? 
                                        <i  
                                            className="icon-cross f-23 pointer marg-l-10 blue-hover"
                                            onClick={() => { this.removeDest(i)}}
                                        ></i>
                                        : 
                                        null 
                                }
                            </div>;
                        })
                    }

                    <div className="pointer underline-hover" onClick={_ => { this.addDest(); }}>
                        <i className="icon icon-plus marg-r-5"></i> 
                        Ajouter un destinataire
                    </div>
                </div>
                <br />

                { /* Title block */ }
                <div className="bold">Titre *</div>
                <br />
                <div>
                    { errors.title && <p className="red">{errors.title}</p> }
                    <Input 
                        placeholder="Titre de l'export ..." 
                        value={title} 
                        className={errors.title ? 'error' : ''}
                        onChange={e => { this.setState({title: e.target.value}); }} 
                    />
                </div>
                <br />
            </div>

            <div className="center marg-t-20">
                {
                    editMode ? 
                        <div className="d-flex justify-content-between align-content-center">
                            <div className="d-flex align-items-center">
                                <div className="red underline-hover f-18 pointer" onClick={() => { this.setState({confirmOpen: true});}}>
                                    supprimer
                                    <i className="marg-l-10 icon icon-delete"></i>
                                </div>
                            </div>
                            <div>
                                <Button className="text-uppercase marg-r-10" size="sm" color="danger" outline onClick={onCancel}>Annuler</Button>
                                <Button className="text-uppercase" size="sm" color="primary" onClick={this.exportData}>Enregistrer</Button>
                            </div>
                        </div>
                        :
                        <Button className="text-uppercase" color="primary" onClick={this.exportData}>Valider</Button>
                }
            </div>

            { confirmOpen && this.showConfirmModal() }

        </div>;
    }
}



// WEBPACK FOOTER //
// ./src/components/Operations/Export/Forms/Rec.js